let client1;
let client2;

window.onload = function () {
  try {
    client1 = new ca.rm.Client();
    let baseUrl = decodeURIComponent(window.location.href);
    client1.setProperty("baseurl", baseUrl.substring(0, baseUrl.indexOf("/openbanking") + 12));
    client1.loadFlash(function () {
      client1.setProperty("format", "json");
      client1.setProperty("didname", "DeviceidRba");
      client1.setProperty("noFlash", true);
      client1.setProperty("mescmaxIterations", 2);
      client1.setProperty("mesccalibrationduration", 200);
      client1.setProperty("mescintervaldelay", 50);
      client1.processDNA();
      localStorage.setItem('rkm', client1.getDNA());
      client2 = new ca.rm.Client();
      client2.setProperty("baseurl", "js/lib");
      client2.setProperty("format", "json");
      client2.setProperty("didname", "deviceid");
      client2.setProperty("store", "cookie");
      client2.setProperty("store", "localstorage");
      client2.setProperty("jobs", ["browser", "system"]);
      client2.loadFlash(function () {
        client2.processDNA();
        let preRicordami = readCookie("preRicordami");
        let ricordami = readCookie("ricordami");
        let deviceID = CryptoJS.SHA1(client2.getDNA() + preRicordami);
        if (preRicordami && ricordami) {
          localStorage.setItem('preRicordami', preRicordami);
          localStorage.setItem('ricordami', ricordami);
          localStorage.setItem("deviceID", deviceID);
        } else {
          console.error('missing cookies', preRicordami, ricordami);
        }
      });
    });
  } catch (e) {
    console.error(e.message);
  }
}

function readCookie(cookie) {
  for (let b = cookie + "=", c = document.cookie.split(";"), d = 0; d < c.length; d++) {
    let e;
    for (e = c[d]; " " === e.charAt(0);) {
      e = e.substring(1, e.length);
    }
    if (0 === e.indexOf(b)) {
      return e.substring(b.length, e.length);
    }
  }
  return null;
}
